<template lang="html">
  <img class="pt-3 mb-4" src="@/assets/logo.svg" alt="logo" width="250" />
  <h1 class="pb-1 title">What do you think was missing at the party?</h1>
  <h2 class="pb-2 subtitle">
    what should definitely be included at the summer party?
  </h2>
  <div class="d-grid gap-2">
    <textarea
      v-model="openAnswer"
      class="form-control form-control-lg rounded-0 field"
      rows="6"
      placeholder="Type your answer here..."
    ></textarea>

    <button
      type="button"
      class="btn btn-primary btn-lg rounded-pill"
      @click="setQuestionTwo()"
      :disabled="!isValidAnswer"
    >
      <span>Next</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionTwoScreen",
  data: () => ({
    openAnswer: "",
  }),
  methods: {
    setQuestionTwo() {
      this.$store.commit("setQuestionTwo", this.openAnswer.trim());
    },
  },
  computed: {
    isValidAnswer() {
      return this.openAnswer.trim().length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
h1 {
  font-family: $font-family-serif;
  font-size: 30px;
  color: $text-color;
}
.unselected {
  border: none !important;
  background-color: $info;
  color: $primary !important;
  /* border-color: #000744 !important; */
}

.field::placeholder {
  color: $info;
}

.subtitle {
  font-family: $font-family-sans-serif;
  font-size: 18px;
  color: $subheader-color;
}
</style>
